import React, {Component} from 'react'

class Tag extends Component {
	constructor(props) {
		super(props);
	}

	// 선택된 옵션 제거 이벤트
	removeItem = (event, data) => {
		event.preventDefault();

		this.props.RemoveEvent(event, data)
	}

	render() {
		return (
			<>
				{
					this.props.selectData.length > -1 &&
					<div className="mt-3">
						<div className="alert-group">
							<div className="alert-group-inner">
								{
									this.props.selectData.map((data, idx) => {
										return (
											<div key={idx} className="alert alert-blue">
												<button
													name={this.props.name}
													type="button"
													className="btn-alert-close icon icon-size-24 icon-close-blue"
													value={data.value}
													onClick={(e) => this.removeItem(event, data)}>
													X
												</button>
												{data.name}
											</div>
										)
									})
								}
							</div>
						</div>
					</div>
				}
			</>
		)
	}
}

export default Tag;
